import { Fragment, useContext, useEffect } from "react";
import { Accordion, Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "./../../../utils/PaginationList/PaginationList";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import {
  convertDate,
  numberSeparate,
  rateType,
  defaultPicture,
  separateScheduleTime,
} from "../../../utils";
import { orderOrganContext } from "../../../context/Organ/OrderOrganContext/OrderOrganContext";
import { ConvertCurrency } from "../../../utils/Currency/Currency";

const OrderOrgan = () => {
  const appTypeChoice = useSelector(
    (state) => state.appConfigs.APP_TYPE_CHOICES
  );

  const {
    orders,
    order,
    config,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    isShowDetailsModal,
    handleShowDetailsModal,
    handleCloseDetailsModal,
    handleGetOrders,
    handleGetOrder,
  } = useContext(orderOrganContext);

  useEffect(() => {
    handleGetOrders();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="سفارشات" />

      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Organ/Dashboard", type: "l" },
          { name: "سفارشات", type: "a" },
        ]}
        title="لیست سفارشات"
      />

      <CardLayout>
        {isEmpty(orders) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>نوع سفارش</th>
                  <th>زمان ارائه</th>
                  <th>نام و نام خانوادگی مشتری</th>
                  <th>شماره موبایل مشتری</th>
                  <th>سازمان مشتری</th>
                  <th>نام پرسنل</th>
                  <th>T/S/C</th>
                  <th>وضعیت</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {orders.map((_item, index) => (
                  <tr>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {index + 1}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {_item.service}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {separateScheduleTime(_item.schedule_time)}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {_item?.client?.first_name} {_item?.client?.last_name}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {_item?.client?.mobile}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {!isEmpty(_item?.personnel) &&
                        _item?.personnel?.map((_personnelVal, index) => (
                          <span
                            className={`d-block ${
                              index + 1 !== _item?.personnel.length
                                ? "border-bottom"
                                : ""
                            }`}
                          >
                            <TooltipTitle
                              title={_personnelVal?.mobile ?? "ندارد"}
                              placement="bottom"
                            >
                              <span className="mx-1">
                                {_personnelVal?.first_name}{" "}
                                {_personnelVal?.last_name}
                              </span>
                            </TooltipTitle>
                          </span>
                        ))}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {_item?.need_special_personnel ? (
                        <span className="badge badge-primary font-weight-bold">
                          ویژه
                        </span>
                      ) : (
                        <span className="badge badge-secondary font-weight-bold">
                          عادی
                        </span>
                      )}
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      <TooltipTitle
                        placement="bottom"
                        title="کل سفارشات از این نوع/سفارشات موفق مشتری/کل سفارشات مشتری"
                      >
                        <span>
                          {_item?.total}/{_item?.successful}/{_item?.this}
                        </span>
                      </TooltipTitle>
                    </td>
                    <td
                      onClick={() =>
                        handleGetOrder(_item?.pk, handleShowDetailsModal)
                      }
                      className="cursorPointer"
                    >
                      {config?.STATUS_CHOICES &&
                        _item?.status >= 0 &&
                        config?.STATUS_CHOICES[_item?.status]}
                    </td>
                    <td />
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <Accordion defaultActiveKey="0" alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>اطلاعات مشتری</Accordion.Header>
            <Accordion.Body>
              <div className="row">
                {/* User */}
                <ItemInfo label="نام و نام خانوادگی">
                  <p>
                    {order?.client?.first_name} {order?.client?.last_name}
                  </p>
                </ItemInfo>
                <ItemInfo label="شماره موبایل">
                  <p>
                    <a href={`tel:${order?.client?.mobile}`}>
                      {order?.client?.mobile}
                    </a>
                  </p>
                </ItemInfo>
                <ItemInfo label="آدرس">
                  <p>{order?.address?.address}</p>
                </ItemInfo>
                <ItemInfo label="تاریخ ثبت سفارش">
                  <p>{convertDate(order?.created)}</p>
                </ItemInfo>
                {/* Other */}
                <ItemInfo label="وضعیت">
                  <p>
                    {config.STATUS_CHOICES_USER &&
                      config.STATUS_CHOICES_USER[order?.status]}
                  </p>
                </ItemInfo>
                <ItemInfo label="نوع پرسنل سفارش">
                  <p>
                    {order?.need_personnel_special ? (
                      <span className="badge badge-primary">ویژه</span>
                    ) : (
                      <span className="badge badge-secondary">عادی</span>
                    )}
                  </p>
                </ItemInfo>
                <ItemInfo label="کد پیگیری">
                  <p>{order.ref_num}</p>
                </ItemInfo>
                <ItemInfo label="نسخه اپ">
                  <p>
                    {order?.client?.app_type
                      ? `${
                          appTypeChoice?.split("،")[order?.client?.app_type - 1]
                        } ${order?.client?.app_version}`
                      : "- -"}
                  </p>
                </ItemInfo>
                {order?.personnel_notification && (
                  <ItemInfo label="پیام پرسنل">
                    <p>{order?.personnel_notification}</p>
                  </ItemInfo>
                )}
                {order?.rating > 0 && (
                  <ItemInfo label="امتیاز">
                    <p>
                      <TooltipTitle
                        placement="bottom"
                        title={`${order?.rating} ستاره`}
                      >
                        <span>{rateType(order?.rating)}</span>
                      </TooltipTitle>
                    </p>
                  </ItemInfo>
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
          {/* Discount */}
          {!isEmpty(order?.discount?.title) && (
            <Accordion.Item eventKey="1">
              <Accordion.Header>کدتخفیف</Accordion.Header>
              <Accordion.Body>
                <section>
                  <p className="alert alert-success text-center">
                    <span className="fw-bold">{order?.discount?.percent}</span>{" "}
                    درصد تخفیف{" "}
                    {order?.discount?.min_invoice_amount && (
                      <span>
                        برای سفارشهایی با مبلغ حداقل{" "}
                        <ConvertCurrency
                          price={order?.discount?.min_invoice_amount}
                        />{" "}
                        ریال
                      </span>
                    )}{" "}
                    تا سقف{" "}
                    <ConvertCurrency
                      price={order?.discount?.max_discount_amount}
                    />
                    ریال بر روی سفارش اعمال شده است
                  </p>
                  <p className="alert alert-primary text-center">
                    عنوان: {order?.discount?.title}
                    <br />
                    کد تخفیف: {order?.discount?.ref_num}
                    <hr />
                    {order?.discount?.percent} مبلغ تخفیف:{" "}
                    <ConvertCurrency price={order?.discount?.amount} />
                    <br />
                    درصد تخفیف: {order?.discount?.percent}%<br />
                    حداقل مبلغ فاکتور{" "}
                    <ConvertCurrency
                      price={order?.discount?.min_invoice_amount}
                    />
                    <br />
                    حداکثر میزان تخفیف:{" "}
                    <ConvertCurrency
                      price={order?.discount?.max_discount_amount}
                    />
                  </p>
                </section>
              </Accordion.Body>
            </Accordion.Item>
          )}
          {/* Personnel */}
          {!isEmpty(order?.personnel) && (
            <Accordion.Item eventKey="2">
              <Accordion.Header>پرسنل</Accordion.Header>
              <Accordion.Body>
                {order?.personnel?.map((_personnel) => (
                  <>
                    <div className="row mb-2 align-items-center justify-content-between">
                      <div className="col-auto">
                        <img
                          className="img-fluid rounded-circle shadow"
                          src={
                            _personnel?.base64
                              ? `data:image/jpeg;base64,${_personnel?.base64}`
                              : defaultPicture
                          }
                          width={65}
                          height={65}
                          alt={`${_personnel?.first_name} ${_personnel?.last_name}`}
                        />
                      </div>
                      <div className="col">
                        <h5 type="button" className="mb-0 fw-bold">
                          {_personnel?.first_name} {_personnel?.last_name}
                        </h5>
                      </div>
                      <div className="col-auto text-center">
                        <TooltipTitle
                          title={`تماس با متخصص ${_personnel?.mobile}`}
                          placement="bottom"
                        >
                          <a href={`tel:${_personnel?.mobile}`}>
                            <i className="fa fa-phone fa-2x" />
                          </a>
                        </TooltipTitle>
                      </div>
                    </div>
                    <hr />
                  </>
                ))}
              </Accordion.Body>
            </Accordion.Item>
          )}
          {/* Survey */}
          <Accordion.Item eventKey="3">
            <Accordion.Header>نظرسنجی</Accordion.Header>
            <Accordion.Body>
              {isEmpty(order?.surveyitems) ? (
                <EmptyData title="نظرسنجی برای نمایش یافت نشد" />
              ) : (
                <div className="row">
                  {order?.surveyitems?.map((_survey) => (
                    <ItemInfo>
                      <div className="row align-items-center justify-content-between">
                        <div className="col-auto">
                          <img
                            className="img-fluid rounded-circle shadow"
                            src={`${config.APP_DOWNLOAD_LINK}/static/console/${_survey.icon}`}
                            width={45}
                            height={45}
                            alt={`${_survey?.description}`}
                          />
                        </div>
                        <div className="col">
                          <h6 className="mb-0 fw-bold">
                            {_survey?.description}
                          </h6>
                        </div>
                      </div>
                    </ItemInfo>
                  ))}
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>
          {/* Invoice */}
          {order.invoice?.pk && (
            <Accordion.Item eventKey="4">
              <Accordion.Header>فاکتور</Accordion.Header>
              <Accordion.Body>
                <div className="row align-items-center">
                  <ItemInfo label="شماره فاکتور">
                    {numberSeparate(order?.invoice?.pk)}
                  </ItemInfo>

                  <ItemInfo label="اجرت (ریال)">
                    <ConvertCurrency price={order?.invoice?.fee} />
                  </ItemInfo>

                  <ItemInfo label="هزینه قطعه (ریال)">
                    <ConvertCurrency price={order?.invoice?.piece} />
                  </ItemInfo>

                  <ItemInfo label="ایاب و ذهاب (ریال)">
                    <ConvertCurrency price={order?.invoice?.transportation} />
                  </ItemInfo>
                  <ItemInfo label="مالیات (ریال)">
                    <ConvertCurrency price={order?.invoice?.tax} />
                  </ItemInfo>

                  <ItemInfo label="تخفیف (ریال)">
                    <ConvertCurrency price={order?.invoice?.amount} />
                  </ItemInfo>

                  <ItemInfo label="فاکتور رسمی">
                    <i
                      className={`fa fa-${
                        order?.invoice?.is_official ? "check" : "times"
                      } text-${
                        order?.invoice?.is_official ? "success" : "danger"
                      }`}
                    />
                  </ItemInfo>
                  <ItemInfo label="پرداخت شده">
                    <i
                      className={`fa fa-${
                        order?.invoice?.is_paid ? "check" : "times"
                      } text-${order?.invoice?.is_paid ? "success" : "danger"}`}
                    />
                  </ItemInfo>

                  <ItemInfo label="نوع پرداخت">
                    <p>{order?.invoice?.method === 1 ? "آنلاین" : "نقدی"}</p>
                  </ItemInfo>

                  <ItemInfo label="مجموع (ریال)">
                    <ConvertCurrency price={order?.invoice?.total} />
                  </ItemInfo>
                  <ItemInfo label="توضیحات">
                    <p>{order?.invoice?.description}</p>
                  </ItemInfo>
                  {!isEmpty(order?.invoice?.items) && (
                    <div className="col-12">
                      <Table responsive hover borderless>
                        <thead className="thead-light">
                          <th>عنوان</th>
                          <th>مبلغ (ریال)</th>
                          <th>توضیحات</th>
                        </thead>
                        <tbody>
                          {order?.invoice?.items?.map((_inv, idx) => (
                            <tr key={idx}>
                              <td>{_inv.name}</td>
                              <td>
                                <ConvertCurrency price={_inv?.price} />
                              </td>
                              <td>{_inv.description}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}
          {/* Values */}
          <Accordion.Item eventKey="5">
            <Accordion.Header>جزئیات</Accordion.Header>
            <Accordion.Body>
              <OrderValues values={order?.values} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default OrderOrgan;

const OrderValues = ({ values }) => {
  if (!values) return null;

  const renderValue = (value) => {
    let render = null;

    if (value.value !== 0 && !value.value && isEmpty(value.values)) return null;

    switch (value.type) {
      case "radiobutton":
        const radioList = value.list?.split("،");
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>
            <div className="card-body">
              {radioList.map(
                (rl, index) =>
                  index === value.value && <span key={index}>{rl}</span>
              )}
            </div>
          </div>
        );
        break;
      case "multiplechoice":
        const multiplechoiceList = value.list?.split("،");
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>
            <div className="card-body">
              {multiplechoiceList.map(
                (rl, index) =>
                  index === value.value && <span key={index}>{rl}</span>
              )}
            </div>
          </div>
        );
        break;
      case "text":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body">{value.value}</div>
          </div>
        );
        break;
      case "datetime":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body text-start" dir="ltr">
              {value.value}
            </div>
          </div>
        );
        break;
      case "number":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body">{value.value}</div>
          </div>
        );
        break;
      case "switch":
        render = (
          <div className="card mb-3">
            <div className="card-header">{value.name}</div>{" "}
            <div className="card-body">{value.value ? "دارد" : "ندارد"}</div>
          </div>
        );
        break;
      case "item":
        render = (
          <div className="card mb-3">
            <div className="card-header">موارد انتخابی</div>{" "}
            <div className="card-body">
              {value.values?.map((primaryValue) =>
                primaryValue.values?.map((subValue) =>
                  renderItemValue(subValue)
                )
              )}
            </div>
          </div>
        );
        break;

      default:
        render = null;
        break;
    }

    return (
      <div className="col-12 col-md-6" key={Math.random()}>
        {render}
      </div>
    );
  };

  const renderItemValue = (value) => {
    let render = null;

    if (value.value !== 0 && !value.value && isEmpty(value.values)) return null;

    switch (value.type) {
      case "switch":
        render = <div className="border-bottom py-1">{value.name}</div>;
        break;
      case "number":
        render = (
          <div className="border-bottom py-1">
            {value.name} : <span>{value.value}</span>
          </div>
        );
        break;
      case "radiobutton":
        const radioList = value.list?.split("،");
        render = (
          <div className="border-bottom py-1">
            <span className="me-2">{value.name}:</span>
            <span>
              {radioList.map(
                (rl, index) =>
                  index === value.value && <span key={index}>{rl}</span>
              )}
            </span>
          </div>
        );
        break;

      default:
        render = null;
        break;
    }

    return <Fragment key={Math.random()}>{render}</Fragment>;
  };

  return (
    <div className="row col-12">
      {values.map((value) => renderValue(value))}
    </div>
  );
};
